import React, { useEffect } from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/activeMembersSagas";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import MembershipChart from "./smartComponents/MembershipChart";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import DatePicker from "./smartComponents/DatePicker";
import "./activeMembers_common.css.scss";
import LearnMore from "../../../../components/learnMore/learnMore";

const ActiveMembers = ({ params }) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    filtersDirty,
    updatesLoading,
    selectedRequestDates: { startDate, endDate }
  } = useSelector((state) => state.activeMembers);

  const renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className="top-filter__right">
              <div className="date-select-box monthly">
                <p>Date</p>
                <DatePicker />
              </div>
              {renderUpdateBtn()}
              {renderResetBtn()}
            </div>
          </div>
        </div>
        <div className="chart-root">
          {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <MembershipChart />}
        </div>
      </div>
    );
  };
  return (
    <div id="activeMembers-root">
      <SectionToggle
        autoHeight
        paddingBottom={0}
        height={690}
        title="Active Memberships"
        learnMore={<LearnMore {...learnMoreProps()} />}
        isLoading={false}
        content={content()}
      />
    </div>
  );
};

const learnMoreProps = () => {
  return {
    learnMoreId: "activeMembers",
    title: "Active Memberships",
    link: "https://intercom.help/ikizmet/en/articles/4069531-active-memberships",
    content: "Use this Membership chart to understand where you are losing and gaining members.",
    direction: "right"
  };
};
export default ActiveMembers;
ActiveMembers.propTypes = {
  params: PropTypes.object
};
